import { createApp } from 'vue';
import MediaIndex from '../vue/Media/MediaIndex.vue';

export default class Map {
	static init(e) {
		const containerElement = e.detail.element;
		const els = containerElement.querySelectorAll('[data-media]');

		els.forEach((el) => new this(el));
	}

	constructor(el) {
		this.el = el;
		const app = createApp(MediaIndex, JSON.parse(this.el.querySelector('script').textContent));
		app.mount(this.el);

		this.el.addEventListener('afterLeave', () => {
			app.unmount();
		});
	}
}
